import { useSelector } from "react-redux";
import type { ApplicationState } from "@ppb/tbd-store";
import { ProductsOption } from "@ppb/tbd-store/state/entities/user-preferences/UserPreferences.types";
import { createProductPreferenceWithProductSwitcherSelector } from "@ppb/tbd-store/state/entities/user-preferences/user-preferences-selectors";

const getProductPreference = createProductPreferenceWithProductSwitcherSelector();

// Read through its own hook, like useIsExchangeMarketCard, so components that bypass their connected
// container (PebbleCardGroup's OpenBetsSlot, RaceMeetingView's OpenBet) can be tested by mocking one
// hook rather than driving the preferences state through useSelector.
export const useIsExchangeProduct = (): boolean =>
  useSelector(
    (state: ApplicationState) => getProductPreference(state.entities.preferences) === ProductsOption.exchange,
  );
